import React from "react";
import {Container, Row, Col, Card} from "react-bootstrap";
import { Animated } from "react-animated-css";
// import CmsIcon from "../assets/images/icons/d_cms_icn.png";
// import CommerceIcon from "../assets/images/icons/d_commerce_icn.png";
// import MobilityIcon from "../assets/images/icons/d_mobility_icn.png";
import { useEffect, useState } from "react";
import { industrytabAPI, industrytabNewAPI } from "../API/industryAPI";
import {motion} from "framer-motion";

const IndustryBlog = (data) => {
    const [cardpanel, setcardpanel] = useState([]);
    const [cardData, setcardData] = useState([]);
    const cardDetail=[];
    const propcopy=data.data;
    const count=propcopy+3;

    const businessTextAnimate={
      offscreen:{y:100, opacity:0},
      onscreen:{
        y:0,
        opacity:1,
        transition:{
        type:"spring",
        ease: "easeInOut",
        bounce:0.4,
        duration:3,
        
        }
      }
    }

  useEffect(() => { 

    var config = { "Access-Control-Allow-Origin": "*" }
    industrytabNewAPI(config, (response) => {
    //success
    const industrycard = response.data.map(item => item.contentElements);
    const industrycardcontent = industrycard[0].map(item => item.contentElementsPart2);
    const industrydetailCard = industrycardcontent[0].map(item => item.ElementsPart);
    //console.log("data transfer",industrydetailCard[propcopy])
    setcardpanel(industrydetailCard[propcopy]);
    for(let i=0;i<industrycard.length;i++)
                {
                  cardDetail.push(industrycardcontent[i].map(list=> list.ElementsPart));
                }
    //console.log("industry data",cardDetail);
    setcardData(cardDetail[0]);
    },(err) => {
        //error
        console.log(err);
    });
      
  }, []);
  //console.log("data",cardpanel)
return(
    <div className="bics-industry-blog py-3 py-md-5 py-lg-5 pt-md-0 pt-lg-0">
       <Container>
       <motion.div className='bics-flip-front'
                   initial={"offscreen"} 
                   whileInView={"onscreen"}
                   viewport={{once:false, amount:0.1}}
                   transition={{staggerChildren:0.5}}
                  >
        <Row>
        {cardpanel.map((item, index) => (
        <Col xs={12} md={12} key={index}>
        <motion.div className='d-flex align-items-center bics-indus-blog-inner' variants={businessTextAnimate}>
          
            <div className="flex-grow-1 ms-3">
                <h3>{item.ElementTittle}</h3>
                <p>{item.ElementDescription}</p>
            </div>
            <div className="flex-shrink-0 align-right">
                <img src={process.env.REACT_APP_BASE_URL + item.ElementImage} alt="CmsIcon" />
            </div>
        </motion.div>

        </Col>
        ))}
        </Row>
        </motion.div>
       </Container>
    </div>
)
}

export default IndustryBlog;
